import { type ComponentType, type ReactElement } from 'react';
import { type ArticleContent } from 'types/wellbeing';
import BulletsContent from './components/Bullets';
import HeadingContent from './components/Heading';
import ParagraphContent from './components/Paragraph';
import { ARTICLE_CONTENT_TYPES } from './types';

export const processTextWithBold = (text: string): ReactElement => {
  const linesWithBold = text.split('\n').map((line, lineIndex) => {
    const parts = line.split(/(\*\*.*?\*\*)/g);
    const processedLine = (
      <>
        {parts.map((part, index) => {
          if (part.startsWith('**') && part.endsWith('**')) {
            const boldText = part.slice(2, -2);
            return <strong key={index}>{boldText}</strong>;
          }
          return part;
        })}
      </>
    );
    return (
      <span key={lineIndex}>
        {processedLine}
        {lineIndex < text.split('\n').length - 1 && <br />}
      </span>
    );
  });

  return <>{linesWithBold}</>;
};

const ContentMap: Record<string, ComponentType<{ contentItem: ArticleContent }>> = {
  [ARTICLE_CONTENT_TYPES.PARAGRAPH]: ParagraphContent,
  [ARTICLE_CONTENT_TYPES.HEADING]: HeadingContent,
  [ARTICLE_CONTENT_TYPES.BULLETS]: BulletsContent,
};

export const renderContent = (contentItem: ArticleContent, index: number): ReactElement | null => {
  const props = { contentItem };
  const Component = ContentMap[contentItem.type];
  const key = `${contentItem.type}-${index}`;

  return Component ? <Component key={key} {...props} /> : null;
};
